export const getUserDateTimeFormat = (
  dateFormat?: 'MM-DD-YYYY' | 'DD-MM-YYYY',
  hoursFormat?: '12_hours' | '24_hours',
) => {
  if (!dateFormat || !hoursFormat) {
    return 'MM-dd-yyyy HH:mm';
  }
  const dateMonthYear = dateFormat === 'DD-MM-YYYY' ? 'dd-MM-yyyy' : 'MM-dd-yyyy';
  const timeFormat = hoursFormat === '12_hours' ? 'hh:mm a' : 'HH:mm';
  return `${dateMonthYear} ${timeFormat}`;
};
